module.exports = "./img/e1940d39bc18ad66d3803ea4161f388b.jpg";